const isRequired = (value) => ((!value && value !== 0) || !String(value).trim()) && "Required";

export default isRequired;
